import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  > div {
    width: 50%;
  }

  > div:not(:last-child) {
    margin-right: 30px;
  }
`;

export const CivilityWrapper = styled.div`
  display: flex;
`;
